import { useContext } from 'react'

import DialogCommon from './DialogCommon'
import { DialogCurrentJobContext, disableJob, formatMessage } from './useDialog'

export default function Dialog() {
  const { currentJob, preJob } = useContext(DialogCurrentJobContext)
  const { message } = currentJob || (preJob && disableJob(preJob)) || {}

  return (
    <DialogCommon>
      <div>{formatMessage(message)}</div>
    </DialogCommon>
  )
}
